import { colorSchemes, colors } from './colorScheme.css.vanilla.mjs';

const getColorScheme = (colorScheme) => colorSchemes[colorScheme.title];
const getColor = (colorScheme) => colors[colorScheme.title];

export { getColor, getColorScheme };
